import { MainContainerWrapper, MainPadding } from "../../styles/Main.styles";
import { useState } from "react";
import TableFC, { TableFCBodyProps } from "../../components/table/Table";
import { useDeleteExpense, useGetListExpense } from "./network/resolver";
import TableHeader from "../../components/table/TableHeader";
import { ModalFC } from "../../components/modal/Modal";
import ExpenseCategoryForm from "./__components/Form";
import { IExpense } from "./Expense.type";
import {
  Box,
  Button,
  CircularProgress,
  debounce,
  TextField,
} from "@mui/material";
import { InputRangeDate } from "../../components/input/input";
import { useGetListCategoryExpense } from "../expense-category/network/resolver";
import { useGenerateAutoCompleteSearch } from "../../components/input/hook/useGenerateOptions";
import {
  AutocompleteOption,
  SearchAutocomplete,
} from "../../components/input/AutocompleteSearch";
import { useParamUrl } from "../invoice/hooks/param/Param";

export default function Expense() {
  const { getPage, setUrlPage } = useParamUrl();
  const [page, setPage] = useState(getPage());
  const [perPage, setPerPage] = useState(10);
  const [keyword, setKeyword] = useState<string>();
  const [dateFrom, setDateFrom] = useState<string>();
  const [dateTo, setDateTo] = useState<string>();
  const [keywordCategory, setKeywordCategory] = useState("");
  const [expenseCategoryId, setExpenseCategoryId] =
    useState<AutocompleteOption | null>(null);
  const { mutate: mutateDelete, isLoading: loadingDelete } = useDeleteExpense();
  const { data: dataRawListExpense, isLoading: loadingFetch } =
    useGetListExpense({
      expense_category_id: expenseCategoryId?.value,
      date_to: dateTo,
      date_from: dateFrom,
      keyword,
      page,
      perPage,
    });
  const dataListCategoryExpense = dataRawListExpense?.data?.data?.data;
  const [showModal, setShowModal] = useState(false);
  const [selected, setSelected] = useState<IExpense | undefined>(undefined);
  const [toDeleteId, setToDeleteId] = useState(0);
  const { data: dataRawExpenseCategory, isLoading: loadingCategoryFetch } =
    useGetListCategoryExpense({
      keyword: keywordCategory,
    });
  const dataExpenseCategory = dataRawExpenseCategory?.data?.data?.data;
  const { data: optionsCategoryExpense } = useGenerateAutoCompleteSearch({
    keyForValue: "id",
    keyForText: "name",
    dataSource: dataExpenseCategory,
  });
  const header = ["No", "Nama", "Kategori", "Total", "Tanggal", ""];
  const bodyTable: TableFCBodyProps[] = [
    { key: "name" },
    { key: "expense_category.name" },
    { key: "total_expense", isMoney: true },
    { key: "date", isDate: true },
    {
      key: "",
      newComponent: (item) => {
        setToDeleteId(item.id);
        return loadingDelete && toDeleteId === item.id ? (
          <CircularProgress size={20} />
        ) : (
          <Button
            onClick={() => handleOnDelete(item.id)}
            color="error"
            variant="contained"
            size="small"
          >
            Hapus
          </Button>
        );
      },
    },
  ];

  const handleOnDelete = (id: any) => {
    if (confirm("Apakan Anda Yakin?")) {
      mutateDelete({ expense_id: id });
    }
  };

  const handleOnChange = debounce((value: string) => {
    setKeyword(value);
  }, 250);

  return (
    <MainPadding>
      <MainContainerWrapper>
        <TableHeader
          title="List Expense"
          addButton
          onClickAdd={() => {
            setShowModal(true);
            setSelected(undefined);
          }}
          renderFilter={
            <Box display={"flex"} flexDirection={"column"} gap={2}>
              <TextField
                label="Search"
                onChange={(e) => {
                  setPage(1);
                  handleOnChange(e.target.value);
                }}
              />
              <SearchAutocomplete
                label="Expense Kategori"
                options={optionsCategoryExpense}
                value={expenseCategoryId}
                onChange={(e) => setExpenseCategoryId(e)}
                inputValue={keywordCategory}
                onInputChange={(e) => setKeywordCategory(e)}
              />
              <InputRangeDate
                onChange={(start, end) => {
                  setDateFrom(start);
                  setDateTo(end);
                }}
              />
            </Box>
          }
        />
        <TableFC
          showIndex
          loading={loadingFetch}
          data={dataListCategoryExpense}
          head={header}
          body={bodyTable}
          totalRows={dataRawListExpense?.data?.data?.total}
          onPerPageChange={(e) => setPerPage(e)}
          onPageChange={(e) => {
            setUrlPage(e);
            setPage(e);
          }}
          onCellClick={(e) => {
            setSelected(e);
            setShowModal(true);
          }}
        />
      </MainContainerWrapper>
      <ModalFC
        open={showModal}
        onClose={() => {
          setShowModal(false);
          setSelected(undefined);
        }}
      >
        <ExpenseCategoryForm id={selected?.id} />
      </ModalFC>
    </MainPadding>
  );
}
